import { Pipe, PipeTransform, inject } from '@angular/core';

import { I18nService } from './i18n.service';

@Pipe({
  name: 't',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform {
  private readonly i18n = inject(I18nService);

  public transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    return this.i18n.translate(value);
  }
}
